import { Flex, Typography } from 'antd';
import { CalendarOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';
import Folio from '@/interfaces/Folio';
import useCustomTranslation from '@/hooks/useCustomTranslation';
import FolioStatusTag from './FolioStatusTag';

interface FolioListItemProps {
  item: Folio;
}

const FolioListItem = ({ item }: FolioListItemProps) => {
  const { t } = useCustomTranslation();
  return (
    <Flex
      align="center"
      gap={8}
      style={{ padding: '8px', marginBottom: 4 }}
    >
      <Typography.Text strong code style={{ fontSize: '1rem' }}>
        {item.id}
      </Typography.Text>

      <FolioStatusTag status={item.status} />

      <Flex align="center" gap={4}>
        <CalendarOutlined style={{ color: '#8c8c8c', fontSize: 11 }} />
        <Typography.Text type="secondary">
          {dayjs(item.expirationDate).format('LLL')}
        </Typography.Text>
      </Flex>
    </Flex>
  );
};

export default FolioListItem;
